export enum UnitDeclinationEnum {
  MINUTE = 'minute',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  COMMITTEE = 'committee'
}
